export function capitalizeEachWord(s: string): string {
  return s.replace(/(^\w{1})|(\s+\w{1})/g, (l) => l.toUpperCase());
}
